export default __webpack_public_path__ + "static/1-a43f61f2d78c13ae7d483a3cbbb4e1a3.jpeg";